var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlice92(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.765 2H5.428c-.391 0-.944.233-1.22.513L1.85 4.905c-.276.28-.506.84-.506 1.236v3.384c0 .396.23.956.506 1.236l2.36 2.392c.275.28.828.513 1.219.513h3.337c.39 0 .943-.233 1.22-.513l2.358-2.392c.276-.28.506-.84.506-1.236V6.14c0-.396-.23-.956-.506-1.236L9.984 2.513C9.708 2.233 9.156 2 8.764 2zM5.083 9.875 9.11 5.792M9.11 9.875 5.083 5.792",
    stroke: "#F05625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice92);
export default __webpack_public_path__ + "static/media/slice_92.ab623a9da3121488bf06b439cd079575.svg";
export { ForwardRef as ReactComponent };